require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-in-an-age-where-data-is-king-its-still-only-ideas-that-move-people.json") })
        }
      }, "path---authors-in-an-age-where-data-is-king-its-still-only-ideas-that-move-people");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-in-an-age-where-data-is-king-its-still-only-ideas-that-move-people!./.cache/json/authors-in-an-age-where-data-is-king-its-still-only-ideas-that-move-people.json
// module id = 1289
// module chunks = 231608221292675